import type { TackTerm } from 'src/services/apollo/generated/graphql'

/**
 * Extract the base language code from an i18n locale string.
 * e.g. 'en-US' → 'en', 'zh-TW' → 'zh', 'ja' → 'ja'
 */
export function getBaseLanguageCode(locale: string): string {
  return locale.split(/[-_]/)[0].toLowerCase()
}

export const getLocalizedTackName = (
  tackTerms: Pick<TackTerm, 'category' | 'name'>[] | undefined | null,
  defaultName: string,
  lang: string,
): string => {
  if (!tackTerms || tackTerms.length === 0) return defaultName

  // Try to find a matching term for the given language first
  const matchingTerm = tackTerms.find(term => term.category === lang)
  if (matchingTerm) {
    return matchingTerm.name
  }
  // If no matching term found, use English term as fallback
  const englishTerm = tackTerms.find(term => term.category === 'en')
  if (englishTerm) {
    return englishTerm.name
  }
  // If no English term found, use default name
  return defaultName
}
